import { injectable } from 'inversify';
import 'reflect-metadata';
import { Response } from '@/_shared/_api/models/response.model';
import axiosClient from './axios-client';
import { ERRORS } from '../constants/errors/error-messages.constants';
import { PurchaseBrandReport } from '../models/brand-report/purchase-brand-report.model';
import { CreateReportCartItemsRequest } from '../models/purchase/create-brand-cart-items-request.model';
import { UserReportCartItem } from '../_api/models/user-report-cart-item.model';
import { DeleteReportCartItemsRequest } from '../models/purchase/delete-brand-cart-items-request.model';
import { ReportCartCheckoutRequest } from '../models/purchase/report-cart-checkout-request.model';

@injectable()
export class PurchaseService {
  async createBrandReportPurchaseSession(
    request: PurchaseBrandReport
  ): Promise<Response<string>> {
    try {
      const response = await axiosClient.post<Response<string>>(
        '/api/purchase/brand-report',
        request
      );

      return response.data;
    } catch {
      throw new Error(ERRORS.unexpectedError);
    }
  }

  async addToCart(
    request: CreateReportCartItemsRequest
  ): Promise<Response<boolean>> {
    try {
      const response = await axiosClient.post<Response<boolean>>(
        '/api/purchase/add-to-cart',
        request
      );

      return response.data;
    } catch {
      throw new Error(ERRORS.unexpectedError);
    }
  }

  async getUserReportCartItemsByUserId(
    userId: number
  ): Promise<Response<UserReportCartItem[] | null>> {
    try {
      const response = await axiosClient.get<
        Response<UserReportCartItem[] | null>
      >('/api/purchase/get-report-cart-items', {
        params: {
          id: userId,
        },
      });

      return response.data;
    } catch {
      throw new Error(ERRORS.unexpectedError);
    }
  }

  async getUserReportCartItemsCountByUserId(
    userId: number
  ): Promise<Response<number>> {
    try {
      const response = await axiosClient.get<Response<number>>(
        '/api/purchase/get-report-cart-items/count',
        {
          params: {
            id: userId,
          },
        }
      );

      const apiResponse = response.data;
      return apiResponse;
    } catch {
      throw new Error(ERRORS.unexpectedError);
    }
  }

  async deleteReportCartItems(
    request: DeleteReportCartItemsRequest
  ): Promise<Response<boolean>> {
    try {
      const response = await axiosClient.patch<Response<boolean>>(
        '/api/purchase/delete-cart-items',
        request
      );

      return response.data;
    } catch {
      throw new Error(ERRORS.unexpectedError);
    }
  }

  async createReportCheckoutPurchaseSession(
    request: ReportCartCheckoutRequest
  ): Promise<Response<string>> {
    try {
      const response = await axiosClient.post<Response<string>>(
        '/api/purchase/report-checkout',
        request
      );

      return response.data;
    } catch {
      throw new Error(ERRORS.unexpectedError);
    }
  }
}
